import React from 'react';
import { Select } from 'antd';
import PropTypes from 'prop-types';
const { Option } = Select;
const YFSelect = ({ id, disabled, label, name, placeholder, register, options, error, handleChange, value }) => {
    return (
        <>
            <label htmlFor={name}>{label}</label>
            <Select
                id={id}
                showSearch
                disabled={!disabled}
                value={value}
                name={name}
                className="yf-select"
                style={{ width: '100%' }}
                placeholder={placeholder}
                ref={register}
                onChange={(value) => handleChange({ name, value })}
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
                {options.map((item) => {
                    return (
                        <Option className={item.label} value={item.value} key={item.id}>
                            {item.label}
                        </Option>
                    );
                })}
            </Select>
        </>
    );
};

YFSelect.propTypes = {
    label: PropTypes.string.isRequired,
    //   name: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
};

YFSelect.defaultProps = {
    disabled: true,
};

export default YFSelect;
